import React, { useState } from 'react';
import Login from './Login';
import Register from './Register';

export default function AuthPage() {
  const [mode, setMode] = useState('login');

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center',
      background: '#f4f5f8', padding: '24px 16px',
    }}>

      {/* Logo */}
      <div style={{ textAlign: 'center', marginBottom: 28 }}>
        <div style={{ fontSize: 38, marginBottom: 8 }}>⬡</div>
        <div style={{ fontSize: 26, fontWeight: 800, color: '#1a1f2e', letterSpacing: 2 }}>NETSTOCK</div>
        <div style={{ fontSize: 11, color: '#9ca3af', letterSpacing: 1.5, marginTop: 4 }}>
          RÉSEAU · INFRASTRUCTURE · INVENTAIRE
        </div>
      </div>


      {/* Carte formulaire */}
      <div style={{
        width: '100%', maxWidth: 420,
        background: '#ffffff',
        border: '1px solid #e5e7eb',
        borderRadius: 12,
        boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
        overflow: 'hidden',
      }}>
        {/* Tabs */}
        <div style={{ display: 'flex', borderBottom: '1px solid #f3f4f6' }}>
          {['login', 'register'].map(m => (
            <button key={m} onClick={() => setMode(m)} style={{
              flex: 1, padding: '14px 0',
              background: 'none', border: 'none', cursor: 'pointer',
              fontFamily: 'Inter, sans-serif', fontSize: 12, fontWeight: 600,
              letterSpacing: 1, textTransform: 'uppercase',
              color: mode === m ? '#e8192c' : '#9ca3af',
              borderBottom: mode === m ? '2px solid #e8192c' : '2px solid transparent',
              marginBottom: -1, transition: 'all 0.15s',
            }}>
              {m === 'login' ? 'Connexion' : 'Créer compte'}
            </button>
          ))}
        </div>

        <div style={{ padding: '28px 28px 24px' }}>
          {mode === 'login'
            ? <Login onSwitch={() => setMode('register')} />
            : <Register onSwitch={() => setMode('login')} />}
        </div>
      </div>

      <div style={{ marginTop: 20, fontSize: 11, color: '#9ca3af', textAlign: 'center' }}>
        T&P Partners SARL · Douala, Cameroun
      </div>
    </div>
  );
}